import React from "react";
import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./HallOfFame.css";

const WaveformLeft = () => (
  <svg
    width="80"
    height="24"
    viewBox="0 0 80 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="hof-waveform mx-3"
  >
    <path
      d="M0 12 L40 12 L45 5 L50 19 L55 2 L60 22 L65 5 L70 19 L75 12 L80 12"
      stroke="#ff8a00"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const WaveformRight = () => (
  <svg
    width="80"
    height="24"
    viewBox="0 0 80 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="hof-waveform mx-3"
  >
    <path
      d="M0 12 L5 12 L10 5 L15 19 L20 2 L25 22 L30 5 L35 19 L40 12 L80 12"
      stroke="#d946ef"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const HallOfFame = () => {
  const cardThemes = [
    { color: "#ff2a5f", name: "Ayesha Rain" },
    { color: "#ff8a00", name: "Manish Albela" },
    { color: "#00a3ff", name: "Mehul Mahesh" },
    { color: "#9747ff", name: "Micle Amit" },
    { color: "#ff2a5f", name: "Rajeshwari Singh" },
    { color: "#ff8a00", name: "Ritik Gupta" },
    { color: "#00a3ff", name: "Roy Razneesh" },
  ];

  const data = [
    {
      img: "/Images/hall-of-fame/ayesha-rain.jpg",
      name: "Ayesha Rain",
    },
    {
      img: "/Images/hall-of-fame/manish-albela.jpg",
      name: "Manish Albela",
    },
    {
      img: "/Images/hall-of-fame/mehul-mahesh.jpeg",
      name: "Mehul Mahesh",
    },
    {
      img: "/Images/hall-of-fame/micle-amit.jpg",
      name: "Micle Amit",
    },
    {
      img: "/Images/hall-of-fame/rajeshwari-singh.jpg",
      name: "Rajeshwari Singh",
    },
    {
      img: "/Images/hall-of-fame/ritik-gupta.jpg",
      name: "Ritik Gupta",
    },
    {
      img: "/Images/hall-of-fame/roy-razneesh.jpg",
      name: "Roy Razneesh",
    },
  ];

  return (
    <section className="hall-of-fame-premium">
      <Container fluid>
        <div className="text-center mb-5 hof-header">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="hof-main-title d-flex justify-content-center align-items-center"
          >
            <WaveformLeft />
            <mark>HALL OF FAME</mark>
            <WaveformRight />
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="hof-subtitle mt-3 text-light"
          >
            Some of the biggest artists in the game started their careers at{" "}
            <span className="text-hof-purple">FT Tunes Music</span>
            Think you could be the next to join our Hall of Fame?
          </motion.p>
        </div>
      </Container>

      <div className="hof-slider-container">
        <Swiper
          modules={[Autoplay, Navigation]}
          spaceBetween={20}
          slidesPerView={1}
          navigation={{
            nextEl: ".hof-next",
            prevEl: ".hof-prev",
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          breakpoints={{
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            992: { slidesPerView: 4 },
            1200: { slidesPerView: 5 },
          }}
          className="hof-swiper pb-4"
        >
          {data.map((item, index) => {
            const theme = cardThemes[index % cardThemes.length].color;
            return (
              <SwiperSlide key={index}>
                <motion.div
                  whileHover={{ y: -10 }}
                  className="artist-card-v2"
                  style={{
                    backgroundImage: `url(${item.img})`,
                    boxShadow: `0 10px 30px -10px ${theme}`,
                    border: `1px solid ${theme}40`,
                    borderBottom: `3px solid ${theme}`,
                  }}
                >
                  <div
                    className="artist-card-overlay-v2"
                    style={{
                      background: `linear-gradient(180deg, transparent 40%, ${theme}90 120%)`,
                    }}
                  >
                    <div className="artist-info-v2">
                      <h4 className="artist-name-v2">{item.name}</h4>
                      <div
                        className="artist-underline-v2"
                        style={{ backgroundColor: theme }}
                      ></div>
                    </div>
                  </div>
                </motion.div>
              </SwiperSlide>
            );
          })}
        </Swiper>

        <div className="hof-prev swiper-nav-btn">←</div>
        <div className="hof-next swiper-nav-btn">→</div>
      </div>
    </section>
  );
};

export default HallOfFame;
